import {getAxiosConfig, getUrlFromUri, handleResponse, withCancellation} from 'Shared/utilities/fetchHelpers';
import axiosInstance from 'Shared/utilities/axiosInstance';
import {MarketingFormControllerApi} from 'Documents/api';
import {MarketingFormStateDto} from 'Agent/AgentForms/Marketing/models/Marketing';
import {MarketingFilters, MarketingViewCart} from 'Agent/AgentForms/Marketing//ducks/Marketing';
import {Sort} from 'Shared/components/PagedView/Table/Sort';
import {addFilterParameters, getDate} from 'Shared/utilities/addFilterParameters';
import axios from 'Shared/utilities/axiosInstance';
import {toFormattedDateAsISO} from 'Shared/utilities/DateFormatter';
import {PreviousOrdersFilters} from '../../PreviousOrders/ducks/previousOrders';
import {mapToFormOrderRequestDto} from '../utilities/mapper';

export const documentsRootUri = '/documents';
const marketingApi = new MarketingFormControllerApi(undefined, 'api' + documentsRootUri, axiosInstance);

const getPreviousOrder = (filter?: PreviousOrdersFilters, sort?: Sort, isNewYork?: boolean) =>
  withCancellation(cancelToken =>
    marketingApi.getMarketingPreviousOrdersUsingGET(
      undefined,
      filter?.formNumber.toString(),
      undefined,
      isNewYork,
      toFormattedDateAsISO(filter?.orderDate?.endDate !== undefined ? getDate(filter?.orderDate?.endDate) : ''),
      filter?.orderNumber.toString(),
      toFormattedDateAsISO(filter?.orderDate?.startDate !== undefined ? getDate(filter?.orderDate?.startDate) : ''),
      filter?.pageNumber.toString(),
      filter?.pageSize?.toString(),
      filter?.product?.toString(),
      filter?.quantity?.toString(),
      sort?.column ? sort?.column.toString() : 'orderDate',
      sort?.direction.toString(),
      undefined,
      getAxiosConfig(cancelToken)
    )
  ).then(handleResponse);

const getMarketingForms = (filter?: MarketingFilters, sort?: Sort, isNewYork?: boolean) =>
  withCancellation(cancelToken =>
    marketingApi.getMarketingFormsUsingGET(
      filter?.category.tag === 'SelectedOption' ? filter?.category.value.toString() : '',
      filter?.description.toString(),
      filter?.formNumber.toString(),
      isNewYork,
      filter?.pageNumber?.toString(),
      filter?.pageSize?.toString(),
      sort?.column.toString(),
      sort?.direction.toString(),
      filter?.states.tag === 'SelectedOption' ? filter?.states.value.toString() : '',
      filter?.title.toString(),
      undefined,
      filter?.type.tag === 'SelectedOption' ? filter?.type.value.toString() : '',
      filter?.titleOrType.toString(),
      getAxiosConfig(cancelToken)
    )
  ).then(handleResponse);

const getMarketingFormStates = (state: MarketingFormStateDto) =>
  withCancellation(cancelToken =>
    marketingApi.getMarketingFormsstateUsingGET(state.fid, undefined, undefined, undefined, getAxiosConfig(cancelToken))
  ).then(handleResponse);

const submitFormOrder = (viewCart: MarketingViewCart) =>
  withCancellation(cancelToken =>
    marketingApi.submitFormOrderUsingPOST(
      mapToFormOrderRequestDto(viewCart),
      undefined,
      undefined,
      undefined,
      getAxiosConfig(cancelToken)
    )
  ).then(handleResponse);

const getFormCostCenters = () =>
  withCancellation(cancelToken =>
    marketingApi
      .getMarketingFormsCostCentersUsingGET(undefined, undefined, undefined, getAxiosConfig(cancelToken))
      .then(handleResponse)
  );

export const getValidatedAddress = (address: string, address2: string, city: string, state: string, zip: string) => {
  const axiosConfig = getAxiosConfig();
  const ADDRESS_ROOT_URL: string = 'api/communication/v1/addressValidation';
  return axios
    .get(getUrlFromUri(`${ADDRESS_ROOT_URL}${addFilterParameters({address, address2, city, state, zip})}`), {
      ...axiosConfig,
      headers: {
        ...axiosConfig.headers,
      },
    })
    .then(handleResponse);
};

export default {
  getMarketingForms,
  getMarketingFormStates,
  submitFormOrder,
  getPreviousOrder,
  getValidatedAddress,
  getFormCostCenters,
};
